module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE0IDE4Ij4KICAgIDxwYXRoIGZpbGw9IiM4ODhCOTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTcgMGE3IDcgMCAwIDAtNyA3YzAgNC4wMjggNC41NDMgOS4wNjEgNi4zMSAxMC43MjhhLjk5Ljk5IDAgMCAwIDEuMzY3LS4wMDNDOS40MzQgMTYuMDU3IDE0IDExLjAyNiAxNCA3YTcgNyAwIDAgMC03LTd6bTAgMTBhMyAzIDAgMSAxIDAtNiAzIDMgMCAwIDEgMCA2eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/map-pin.svg
// module id = aGxw
// module chunks = 1